// extracted by mini-css-extract-plugin
export var globalHeader = "header-module--globalHeader--dIk5L";
export var header = "header-module--header--lCLPZ";
export var subsidiaryLogo = "header-module--subsidiaryLogo--SXcPF";